export default {
  feeTab: {
    fee: 'Fee',
    receivable: 'Receivable',
    payable: 'Payable',
    summary: 'Summary',
    detail: 'Detail',
    receivableTotal: 'Receivable',
    receivablePending: 'Pending Receipt',
    payableTotal: 'Payable',
    payablePending: 'Pending Payment',
    feeItems: 'Fee Items',
    feeName: 'Fee Item',
    settlementParty: 'Settlement Party',
    billingUnit: 'Billing Unit',
    settlementUnitPrice: 'Settlement Unit Price',
    quantity: 'Quantity',
    settlementCurrency: 'Settlement Currency',
    settlementAmount: 'Settlement Amount',
    baseCurrency: 'Functional Currency',
    exchangeRate: 'Exchange Rate',
    baseCurrencyAmount: 'Functional Currency Amount',
    source: 'Source',
    sourceSYSTEM: 'SYSTEM',
    sourceMANUAL: 'MANUAL',
    systemCalculatedAmount: 'System Calculated Amount',
    apiAmount: 'API Amount',
    invoiceAmount: 'Invoice Amount',
    status: 'Status',
    writeOffStatus: 'Write-off Status',
    status0: 'Pending Confirmation',
    status1: 'Confirmed',
    verificationStatus0: 'Not Written Off',
    verificationStatus1: 'Written Off',
    trackingNumber: 'Tracking Number',
    packageNo: 'Package Number',
    invoiceNo: 'Invoice Number',
    invoiceWeek: 'Invoice Week',
    expenseTime: 'Expense Time',
    createdBy: 'Created By',
    remark: 'Remark',
    batchConfirm: 'Batch Confirm',
    cancelConfirm: 'Cancel Confirm',
    recalculateFee: 'Recalculate Fee',
    receivableSummaryFileName: 'Receivable Summary Fee.csv',
    receivableDetailFileName: 'Receivable Detail Fee.csv',
    payableSummaryFileName: 'Payable Summary Fee.csv',
    payableDetailFileName: 'Payable Detail Fee.csv',
    addFee: 'Add Fee',
    editFee: 'Edit Fee',
    numberRange: 'Enter a number greater than 0 and no more than {max}',
    billingUnits: {
      kilogram: 'Kilogram',
      ton: 'Ton',
      cubicMeter: 'Cubic Meter',
      shipment: 'Shipment',
      piece: 'Piece',
      carton: 'Carton',
      pallet: 'Pallet',
      container: 'Container',
      occurrence: 'Occurrence',
      hour: 'Hour',
      centimeter: 'Centimeter',
      rate: 'Rate',
    },
  },
};
